import Cal, { getCalApi } from '@calcom/embed-react'
import { useEffect } from 'react'
import { NoiseBackground } from '#app/components/noise-background.tsx' // Adjust the import path as needed

export default function BookDemoPage() {
	const CalNameSpace = '30min'

	useEffect(() => {
		;(async function () {
			const cal = await getCalApi({ namespace: `${CalNameSpace}` })
			cal('ui', {
				hideEventTypeDetails: false,
				layout: 'month_view',
			})
		})()
	}, [])

	return (
		<>
			{/* Calendar Section */}
			<section className="relative z-20 mx-auto max-w-7xl pb-12 pt-24">
				<div className="mx-auto max-w-6xl px-8">
					<NoiseBackground>
						<div className="p-6">
							<div className="text-center">
								<h2 className="font-sans text-2xl font-bold tracking-tight text-white md:text-4xl">
									Schedule Your DealerProEdge Demo Today
								</h2>
								<p className="mx-auto mt-4 max-w-3xl text-base text-neutral-200 md:text-lg">
									Join us for a personalized demo to explore how DealerProEdge
									can enhance your dealership’s performance and streamline your
									operations.
								</p>
							</div>
							<div className="mt-8">
								<Cal
									namespace={CalNameSpace}
									calLink={`dealerproedge/${CalNameSpace}`}
									style={{ width: '100%' }}
									config={{ layout: 'month_view', theme: 'light' }}
								/>
							</div>
						</div>
					</NoiseBackground>
				</div>
			</section>
		</>
	)
}
